import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { InvoiceDataPickerComponent } from './invoice-data-picker.component';

@NgModule({
  declarations: [
    InvoiceDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    InvoiceDataPickerComponent
  ]
})
export class InvoiceDataPickerModule { }
